import { baseQuerySetup,getResponsedata,onQueryStarted, onCacheEntryAdded, transformResponse } from 'config/index';
import { createApi } from '@reduxjs/toolkit/query/react';
import { COMPANY_PREFIX } from 'constants/index';
import { getStateView } from 'utils/address';
import { formatDate } from 'utils/date';
let companyReducer = 'CompanyReducer';
let companyTag = 'companyTag';
let comapnyRequestTag = 'companyRequestTag';

export const companyApi = createApi({
    reducerPath: companyReducer,
    baseQuery: baseQuerySetup,
    tagTypes: [companyTag, comapnyRequestTag],
    endpoints: (builder) => ({
        getApprovals: builder.query({
            query: (params) => {
                const query = new URLSearchParams(params).toString();
                return { url: COMPANY_PREFIX + '/approvals?' + query, method: 'GET' };
                // the search query params
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse: (response) => {
                if (response?.statusCode === 200 || response?.statusCode === 201) {
                    return response.result;
                }
                return response;
            },
            providesTags: [companyTag]
        }),
        approvalAction: builder.mutation({
            query: ({ id , body }) => {
                return { url: COMPANY_PREFIX + '/approvals/' + id, method: 'PUT', body };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse,
            invalidatesTags: [companyTag, comapnyRequestTag]
        }),
        updateLender: builder.mutation({
            query: ({ id , body }) => {
                return { url: COMPANY_PREFIX + '/lender/' + id, method: 'PUT', body };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse,
            invalidatesTags: [companyTag, comapnyRequestTag]
        }),
        getCompanyQuery: builder.query({
            query: (id) => {
                return { url: COMPANY_PREFIX + '/' + id, method: 'GET' };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse: (response) => {
                if (response?.statusCode === 200 || response?.statusCode === 201) {
                    let data = response.result.data;

                    return { ...data,dateFormed: formatDate(data?.dateFormed), Statelicenses: data?.Statelicenses };
                }
                return response;
            },
            providesTags: [companyTag]
        }),
        UpdateCompany: builder.mutation({
            query: ({ id , body }) => {
                return { url: COMPANY_PREFIX + '/' + id, method: 'PUT', body };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse
        }),
        getApprovalRequest: builder.query({
            query: (id) => {
                return { url: COMPANY_PREFIX + '/approvals/' + id, method: 'GET' };
            },
            providesTags: [comapnyRequestTag],
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse: getResponsedata
        }),
        getAllCompanies: builder.query({
            query: (params) => {
                let query = new URLSearchParams(params);
                return { url: COMPANY_PREFIX + '/list?' + query , method: 'GET' };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse: (response) => {
                if (response?.statusCode === 200 || response?.statusCode === 201) {
                    return response.result;
                }
                return response;
            }

        }),
        getCompanyUsers: builder.query({
            query: ({ id , role }) => {
                if (role) {
                    return { url: COMPANY_PREFIX + '/' + id + '/lenders?role=' + role , method: 'GET' };
                } else {
                    return { url: COMPANY_PREFIX + '/' + id + '/lenders', method: 'GET' };
                }
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse: getResponsedata

        }),
        getCompanyStats: builder.query({
            query: (id) => {
                return { url: COMPANY_PREFIX + '/' + id + '/stats' , method: 'GET' };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse: getResponsedata
        }),
        getCompanyUserDetails: builder.query({
            query: (id) => {
                return { url: COMPANY_PREFIX + '/lender/' + id , method: 'GET' };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse: (response) => {
                if (response?.statusCode === 200 || response?.statusCode === 201) {
                    let Statelicenses = response.result.data.Statelicenses.map((value)=>{
                        return { label: getStateView(value), value };
                    });
                    return { ...response.result.data, Statelicenses };
                }
                return response;
            }
        })
    })
});

export const { useGetApprovalsQuery, useUpdateCompanyMutation , useLazyGetAllCompaniesQuery, useLazyGetApprovalsQuery , useApprovalActionMutation , useGetCompanyQueryQuery , useGetApprovalRequestQuery , useGetAllCompaniesQuery, useGetCompanyStatsQuery, useGetCompanyUsersQuery, useGetCompanyUserDetailsQuery, useUpdateLenderMutation } = companyApi;
